import * as types from '../event_types'
import * as restlet from '../actions/rest'
import Vue from 'vue';


// STATE

const state = {
  handbook: {},
  sections: [],
  showNotification: false, 
  notificationMessage: "",
  selectedSection: {}
}

// GETTERS

const getters = {
  handbook: s => s.handbook,
  sections: s => s.sections,
  showNotification: s => s.showNotification,
  notificationMessage: s => s.notificationMessage,
  selectedSection: s => s.selectedSection
}

// ACTIONS

const actions = {
  selectSection({ commit }, section) {
    commit('setSelectedSection', section)
  },
  notify({ commit }, message) {
    commit(types.SET_MESSAGE, message)
    commit(types.SHOW_NOTIFICATION, true)
  },
  getHandbook({ commit, dispatch}) {
    restlet.getHandbook().then(function(response) {
      if (response.status === 200 && response.data && response.data.data) {
        commit(types.SET_HANDBOOK, response.data.data)
        dispatch("getSections")
      }
    })
  },
  saveHandbook({ commit, dispatch }, handbook) {
    if (handbook.id){
      restlet.updateHandbook(handbook).then(function(response) {
        if(response.data && response.data.data) {
          commit(types.SET_HANDBOOK, response.data.data)
          dispatch('notify', `Successfully updated '${handbook.name}'`)
        }
      })
    }else{
      restlet.createHandbook(handbook).then(function(response) {
        if(response.data && response.data.data) {
          commit(types.SET_HANDBOOK, response.data.data)
          dispatch('notify', `Successfully created '${handbook.name}'`)
        }
      })
    }
  },
  sign({ state, commit, dispatch }, name) {
    if (state.handbook.id){
      restlet.signed({'handbook': state.handbook}, name).then(function(response) {
        commit(types.SET_HANDBOOK, response.data.data)
        dispatch('notify', `Successfully signed '${state.handbook.name}'`)
      })
    }
  },
  visit({ state, commit }) {
    if (state.handbook && state.handbook.id){
      restlet.visited({'handbook': state.handbook}).then(function(response) {
        commit(types.SET_HANDBOOK, response.data.data)
      })
    }
  },
  uploadImage({ commit }, image) {
    restlet.uploadImage(image.property, image.img).then(function(response) {
      if(response.data && response.data.image_url) {
        commit(types.SET_IMAGE, response.data)
      }
    })
  },
  async uploadQuillImage(_config, image) {
    return await restlet.uploadImage('', image).then(function(response) {
      return response.data
    })
  },
  addSection({ commit, state }) {
    let section = { order: state.sections.length + 1 }
    commit(types.ADD_SECTION, section)
    return section
  },
  getSections( { commit, state }) {
    if(state.handbook.id){
      restlet.getSections(state.handbook.id).then(function(response) {
        commit(types.SET_SECTIONS, response.data.data)
      })
    }
  },
  saveSection({ state, commit, dispatch }, section) {
    if (section.id){
      restlet.updateSection(state.handbook.id, section).then(function(response){
          dispatch('notify', `Successfully updated '${section.name}'`)
      })
    }else{
      restlet.createSection(state.handbook.id, section).then(function(response) {
        if(response.data && response.data) {
          commit(types.SET_SECTION, response.data.data)
          dispatch('notify', `Successfully created '${section.name}'`)
        }
      })
    }
  },
  deleteSection( { commit, state }, section) {
    restlet.deleteSection(state.handbook.id, section).then(function(response){
      commit(types.SET_SECTIONS, response.data.data)
    })
  },
  removeSection( { commit }, section) {
    commit(types.REMOVE_SECTION, section)
  },
  resetSection( { commit }, section) {
    commit(types.RESET_SECTION, section)
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setHandbook(s, handbook) {
    Vue.set(s, 'handbook', handbook)
  },
  setImage(s, image) {
    Vue.set(s.handbook, image.property, image.image_url)
  },
  setMessage(s, message) {
    Vue.set(s, 'notificationMessage', message)
  },
  showNotification(s, notify) {
    Vue.set(s, 'showNotification', notify)
  },
  addSection(s, section) {
    s.sections.push(section)
    Vue.set(s, 'sections', s.sections)
  },
  setSections(s, sections) {
    Vue.set(s, 'sections', sections)
  },
  removeSection(s, section) {
    s.sections.pop()
    Vue.set(s, 'sections', s.sections)
  },
  resetSection(s, section) {
    let selected = s.sections.findIndex(function(el) {
      return el.id === section.id
    })
    s.sections[selected] = section
    Vue.set(s, 'sections', s.sections)
  },
  setSelectedSection(s, section) {
    Vue.set(s, 'selectedSection', section)
  }
}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
